import React from 'react'

// component
import MenuItemSegment from 'src/components/item_segment/layouts/menu/menu'
import ToggleItemSegment from 'src/components/item_segment/layouts/toggle/toggle'

// helpers
import { textResources } from 'src/lang/de'
import { createBemBlock } from 'src/utils/bem_helper/bem_helper'
import { COLOR_TYPE_BLACK } from 'src/utils/color'
import initTracker, { FOLLOW_BUTTON } from 'src/utils/reporting/events_tracking/events_tracking'

import { NotificationSettingNotifier, useUpdateAllMediumsForNotificationSetting } from '@lopo-tech/lopo-api'
import './follow_popover_menu.scss'

interface IProps {
  hide: () => void;
  showCancelModal: (visible: boolean) => void;
  isNotifying: boolean;
  profileId: string;
}

const wrapperCls = 'follow_popover_menu'
const cls = createBemBlock(wrapperCls)

const label = textResources.follow

const tracker = initTracker(FOLLOW_BUTTON)

const FollowButtonMenu: React.FC<IProps> = ({ showCancelModal, isNotifying, hide, profileId }) => {
  const [updateNotificationSetting] =
    useUpdateAllMediumsForNotificationSetting()

  const toggleNotification = () => {
    tracker(FOLLOW_BUTTON.ACTIONS.SUBSCRIPTION, FOLLOW_BUTTON.LABELS.START)
    updateNotificationSetting({
      variables: {
        enabled: !isNotifying,
        notifier: NotificationSettingNotifier.NewFolloweePost,
        subjectId: profileId
      }
    })
  }

  const notificationText = label[isNotifying ? 'turnOffNotifications' : 'turnOnNotifications']
  return (
    <div className={cls()}>
      <MenuItemSegment
        label={label.unfollow}
        navigation={{ onClick: () => { showCancelModal(true); hide() } }}
        icon={{ name: 'minus-circle' }}
      />
      <ToggleItemSegment
        label={notificationText}
        isChecked={isNotifying}
        onChange={toggleNotification}
        icon={{
          color: COLOR_TYPE_BLACK,
          name: 'bell-new'
        }}
      />
    </div>
  )
}

export default FollowButtonMenu
